import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { FileRecord } from "@/shared/domain/files";

export function useFileRecordTags(fileId: string) {
  const { files } = useDomainServices();

  return useQuery<string[], Error>({
    queryKey: ["fileTags", fileId],
    queryFn: ({ signal }) => {
      return files
        .getFileRecord(fileId, {
          abortSignal: signal,
        })
        .then((record: FileRecord) => {
          return record.tags;
        });
    },
    staleTime: 1000 * 60 * 5,
  });
}
